/* Copyright (c) 2021-2023 VMware, Inc. All rights reserved. -- VMware Confidential */
import * as englishStrings from "./l10n.json";

export const ENGLISH = englishStrings;
